module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/node_modules/core-js/library/modules/_add-to-unscopables.js
// module id = 74
// module chunks = 0